<template>
  <div id="productOverviewPage">
    <b-container>
      <FilterBar></FilterBar>
      <!-- <ProductBoard></ProductBoard> -->
      <div id="wellColumn">
          <Loading v-if="!this.$store.state.products.productDataReady"></Loading>
          <NoResults v-else-if="this.$store.getters.noResults"></NoResults>
          <div id="boardsDiv" v-else-if="this.$store.state.products.productDataReady">
            <ProductBoard v-bind:class="{ displayNone: hideProductBoard }"></ProductBoard>
          </div>
          <p v-else>{{this.$store.state.miscData.miscData.SomethingWentWrongText}}</p>
        </div>
    </b-container>
  </div>
</template>

<!-- #region script -->
<script>
import ProductBoard from "../components/ProductOverviewPage/ProductBoard/ProductBoard";
import FilterBar from "../components/ProductOverviewPage/FilterBar/FilterBar.vue";
import Loading from "../components/ProductOverviewPage/Loading/Loading";
import NoResults from "../components/ProductOverviewPage/NoResults/NoResults";

export default {
  name: "ProductOverviewPage",
  components: {
    ProductBoard,
    FilterBar,
    Loading,
    NoResults,
  },
  computed: {
    hideProductBoard() {
      return !this.$store.state.showProductBoard;
    },
  },
  methods: {
    removeDuplicates: function () {
      let array1 = [
        { id: 4, name: "object4" },
        { id: 2, name: "object2" },
        { id: 3, name: "object3" },
      ];
      let array2 = [
        { id: 1, name: "object1" },
        { id: 4, name: "object4" },
        { id: 3, name: "object3" },
      ];
      let array3 = [
        { id: 5, name: "object5" },
        { id: 2, name: "object2" },
        { id: 4, name: "object4" },
      ];

      let allObjects = array1.concat(array2).concat(array3);
      arrayUniqueObjects(allObjects);

      function arrayUniqueObjects(allObjects) {
        let uniqueObjects = [];
        allObjects.forEach((obj) => {
          let uniqueProperty = obj.id; // The property that the objects will be selected by (uniqueObjects will only contain one object with this property value)
          let inUniqueObjects = arrayContainsItem(obj.id, uniqueObjects);
          if (!inUniqueObjects) {
            uniqueObjects.push(obj);
          }
        });
      }

      function arrayContainsItem(id, array) {
        let containsItem = false;
        array.forEach((obj) => {
          if (obj.id == id) {
            containsItem = true;
          }
        });
        return containsItem;
      }
    },
    getIets: function () {
      let array1 = [
        { id: 1, name: "object1" },
        { id: 2, name: "object2" },
        { id: 3, name: "object3" },
      ];
      let array2 = [
        { id: 1, name: "object1" },
        { id: 2, name: "object2" },
        { id: 3, name: "object3" },
      ];

      let concatArray = array1.concat(array2);

      let uniqueObjects = concatArray.filter((obj) => {
        let inArray1 = arrayContainsItem(obj.id, array1);
        let inArray2 = arrayContainsItem(obj.id, array2);

        if (inArray1 || inArray2) {
          return false;
        }
      });

      function arrayContainsItem(id, array) {
        let containsItem = false;
        array.forEach((obj) => {
          if (obj.id == id) {
            containsItem = true;
          }
        });
        return containsItem;
      }
    },
  },
  // beforeCreate() {
  //   let routedByRedirection = Object.prototype.hasOwnProperty.call(localStorage, "state") ? true : false;
  //   if (routedByRedirection) {
  //     let localStorageState = JSON.parse(localStorage.getItem("state"));
  //     // The state when routed through the HomePage stored in localStorage. See HomePage.vue for more info.
  //     Object.assign(this.$store.state, localStorageState);
  //     delete localStorage.state;
  //   } else {
  //     this.$store.dispatch("getProducts");
  //     this.$store.dispatch("getMiscData");
  //   }
  // },
};
</script>
<!-- #endregion -->
